import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_LOCALSTORAGE, IS_E2E } from '@omnipresentgroup/constants';
import { useEffect, useState } from 'react';

import type { AuthenticatedUser, AuthState } from '../../types';

export const useAuth = () => {
  const initialAuthState = JSON.parse(
    localStorage.getItem(AUTH0_LOCALSTORAGE) || '{}',
  );

  const {
    user: auth0User,
    isLoading,
    error: authError,
    logout,
    getAccessTokenSilently,
    isAuthenticated,
  } = useAuth0<AuthenticatedUser>();

  const [authentication, setAuthentication] =
    useState<AuthState>(initialAuthState);

  const IS_E2E_TESTS = IS_E2E && authentication;

  // Update state only when localStorage changes
  useEffect(() => {
    const onStorageChange = (event: StorageEvent) => {
      if (event.key === AUTH0_LOCALSTORAGE) {
        setAuthentication(JSON.parse(event.newValue || '{}'));
      }
    };

    window.addEventListener('storage', onStorageChange);

    return () => {
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);

  const user = IS_E2E_TESTS
    ? authentication?.body?.decodedToken.claims
    : auth0User;

  return {
    user,
    isLoading,
    authError,
    logout,
    getAccessTokenSilently: IS_E2E_TESTS
      ? () => Promise.resolve(authentication?.body.access_token)
      : getAccessTokenSilently,
    isAuthenticated: IS_E2E_TESTS || isAuthenticated,
  };
};
